import { useEffect, useState } from "react";
import { _getUserGroups, _leaveGroup } from "../../data/users";
import Icon from "@mdi/react";
import { mdiTrashCanOutline } from "@mdi/js";
import { toggleModal } from "../../utils/uiUtils";

function ViewMyGroups({ setGroupsLoading }) {
    const [isLoadingGroups, setIsLoadingGroups] = useState(true);
    const [groups, setGroups] = useState();
    const [selectedGroupId, setSelectedGroupId] = useState();

    useEffect(() => {
        const fetchGroupData = async () => {
            const tmpGroups = await _getUserGroups();
            setGroups(tmpGroups);
            console.log(tmpGroups);
            setIsLoadingGroups(false);
            setGroupsLoading(false);
        }

        fetchGroupData();
    }, [])

    const leaveGroup = async () => {
        toggleModal("modal-leaveGroup");
        toggleModal("loadingModal");
        await _leaveGroup(selectedGroupId);
        const tmpGroups = await _getUserGroups();
        setGroups(tmpGroups);
        toggleModal("loadingModal");
    }

    if (isLoadingGroups)
        return (<></>);

    return (
        <>
            <div className="is-size-5 has-text-weight-bold is-underlined mt-5">
                My groups
            </div>
            <div className="columns">
                <div className="column is-full-tablet is-half-desktop">

                    <table className="table is-striped is-fullwidth ">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Group</th>
                                <th>Leave</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groups && Object.keys(groups).length == 0 &&
                                <tr>
                                    <td colspan="3">You are not a member of any groups.</td>
                                </tr>
                            }
                            {groups && Object.keys(groups).map((groupId, idx) => (
                                <tr key={groupId}>
                                    <td>
                                        <figure className=" image is-32x32">
                                            <img src={groups[groupId].icon} />
                                        </figure>
                                    </td>
                                    <td>{groups[groupId].displayName}</td>
                                    <td className="has-text-danger is-clickable">
                                        <Icon path={mdiTrashCanOutline} size={1.25} onClick={() => { setSelectedGroupId(groupId); toggleModal("modal-leaveGroup") } } />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="modal-leaveGroup" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Leave Group</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-leaveGroup') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="is-size-6">
                            You are about to leave a group. <span className="has-text-weight-bold has-text-danger">This cannot be undone</span>
                        </div>
                        <div className="field mt-3 ml-3 content">
                            <ul>
                                <li>If you rejoin the group, you will not linked to your previous plays and stats</li>
                                <li>If you're the only member of the group, the group will be deleted</li>
                                <li>If there are other members, but you are the only admin. A random person will be assigned as an admin</li>                                
                            </ul>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <button
                            className="button is-danger mr-5"
                            onClick={async () => { leaveGroup(); }}>
                            Leave Group
                        </button>
                        <button className="button" aria-label="close" onClick={() => { toggleModal('modal-leaveGroup') }}>Close</button>
                    </footer>
                </div>
            </div>
        </>
    );
}

export default ViewMyGroups;